import * as d3 from 'd3';

export interface XYPosition {
  x: number;
  y: number;
}

export default function transformPointsToSvgPath(
  points: Array<XYPosition>,
  pointCorrectionX: number = 0,
  pointCorrectionY: number = 0
): string {
  const line = d3
    .line()
    .x((d) => d[0] + pointCorrectionX)
    .y((d) => d[1] + pointCorrectionY)
    .curve(d3.curveBasis);

  return line(points.map((hash) => [hash.x, hash.y]))!;
}
